import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async create(payload) {
    try {
      let data = {
        data: {
          type: "schedule_events",
          attributes: {
            starts_at: payload.starts_at,
            ends_at: payload.ends_at
          },
          relationships: {
            schedules: {
              data: [
                {
                  type: "schedules",
                  id: payload.schedule_id
                }
              ]
            }
          }
        }
      };

      let headers = {
        headers: {
          "X-Use-Time-Zone": payload.time_zone
        }
      };
      let res = await HTTP.normal.post("schedule-events", data, headers);

      return {
        id: res.data.data.id,
        starts_at: res.data.data.attributes.starts_at,
        ends_at: res.data.data.attributes.ends_at,
        status: res.data.data.attributes.status
      };
    } catch (e) {
      throw "Ocorreu um erro ao criar o evento.";
    }
  },

  async remove(id) {
    try {
      await HTTP.normal.delete(`schedule-events/${id}`);
      return true;
    } catch (e) {
      throw "Ocorreu um erro ao deletar o evento.";
    }
  },

  async update(payload) {
    try {
      let data = {
        data: {
          type: "schedule_events",
          id: payload.id,
          attributes: {
            starts_at: payload.starts_at,
            ends_at: payload.ends_at
          }
        }
      };

      let headers = {
        headers: {
          "X-Use-Time-Zone": payload.time_zone
        }
      };

      await HTTP.normal.patch(`schedule-events/${payload.id}`, data, headers);
    } catch (e) {
      throw "Ocorreu um erro ao atualizar o evento.";
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/scheduleEvents.js